import { render, staticRenderFns } from "./bandwai.vue?vue&type=template&id=bb6e494e&scoped=true"
import script from "./bandwai.vue?vue&type=script&lang=js"
export * from "./bandwai.vue?vue&type=script&lang=js"
import style0 from "./bandwai.vue?vue&type=style&index=0&id=bb6e494e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6e494e",
  null
  
)

export default component.exports